<template>
  <div>
    <integral-list v-show="tabType === 1" @handleShow="handleShow" :isIntegral="1" />
    <integral-show v-if="tabType === 2" :rowItem="rowItem" @handleShow="handleShow"  />
  </div>
</template>

<script>
// import integralList from './list.vue'
import integralList from '../../goods/goods/list.vue'
import integralShow from '../../goods/goods/show.vue'
export default {
  components: { integralList, integralShow },
  data() {
    return {
      tabType: 1,
      rowItem: null
    }
  },
  methods: {
    handleShow(row, type) {
      this.rowItem = { ...row }
      this.tabType = type
    }
  }
}
</script>

<style>
</style>